<section>
	<text-group>
		<div>{{ 'company.domains.lookup-result.domain-name' | translate }}</div>
		<div><a href="https://{{dnsResult?.name}}" target="_blank">{{ dnsResult?.name }}</a></div>

		<div>{{ 'company.domains.lookup-result.ip-address' | translate }}</div>
		<div>{{ dnsResult?.ipAddress ?? ('company.domains.no-a-record' | translate) }}</div>

		<div>{{ 'company.domains.lookup-result.name-server' | translate }}</div>
		<div>{{ dnsResult?.nameServer }}</div>
	</text-group>
</section>
